export default __webpack_public_path__ + "static/media/bTRI-CRED.2275b684.png";